module.exports = __webpack_public_path__ + "fonts/WorkSans-ExtraBold.d07d1e3.ttf";